import { useSelectors } from '@exodus/headless-react';
import { useSelector } from 'react-redux';
const useExchangeReady = () => {
    const selectors = useSelectors();
    const availableAssets = useSelector(selectors.availableAssets.all);
    return Object.values(availableAssets).length > 0;
};
export default useExchangeReady;
